// tslint:disable:directive-selector

import { Directive, Input } from "@angular/core";

import { TestTagDirective } from "./tag.directive";

@Directive({
  selector: "[lcFormField][name]",
  exportAs: "taTag"
})
export class TestFieldNameDirective extends TestTagDirective {
  @Input()
  get name(): string {
    return this.taTag;
  }
  set name(value: string) {
    this.taTag = value;
  }
}
